import useApiRequests from "@services/http/useApiRequest";
import { IChangeClientPasswordModalProps } from "./ChangeClientPasswordMoal";
import { ChangeClientPass } from "@services/changeClientPass";
import { ChangeEvent, useState } from "react";
import { makeNotifs } from "@utils/makeNotifs";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { MODALS_ENUM } from "@constants/Modals";
import { ErrorType } from "@components/global/new/Error/Error";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";

export const useChangeClientPasswordModalControl = (
  props: IChangeClientPasswordModalProps
) => {
  const { ok } = makeNotifs();
  const { onSuccess } = useGlobalNotifs();
  const { enqueue } = useApiRequests();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<ErrorType>();

  const onChangehandler = (e: ChangeEvent<HTMLInputElement>) =>
    setPassword(e.currentTarget.value);

  const onChangePass = async () => {
    if (!password) return;
    if (password.length < 6) {
      setErrors({ length: true });
      return;
    }
    dispatch(
      show(MODALS_ENUM.CONFIRM_MODAL, {
        async onConfirm() {
          const res = await enqueue(
            new ChangeClientPass(props.userId, password),
            { onLoadingStatusChanged: setLoading }
          );

          if (!res) return;
          onSuccess(ok.success);
          props.handleDestroy();
        },
        onCancel() {
          props.handleDestroy();
        },
      })
    );
  };

  return {
    password,
    errors,
    loading,

    onChangehandler,
    onChangePass,
  };
};
